export default (...args: any[]) => {
  return useDayjs()(...args)
}
